<template>
  <div class="col-6 col-sm-3 col-xl-2 p-0" :id="'p' + this.provider.id">
    <div class="card text-center p-0">
      <div class="card-header text-light bd-navbar d-flex justify-content-center p-2">
        <h5>
          <a class="text-light" :href="provider.homepage">{{provider.name}}</a>
        </h5>
      </div>
      <content-static-provider-error v-if="hasError" v-on:reload="loadGasPrice" />
      <div class="card text-center p-0" v-for="gasPrice in gasStations" :key="gasPrice.id" v-bind:class="{ 'fav-gas text-light': gasPrice.isFav}">

        <div class="row no-gutters align-items-center">
          <div class="col-4" v-bind:class="{ 'small text-muted1': provider.gastype != 'e5' }">Super</div>
          <div class="col-4" v-bind:class="{ 'small text-muted1': provider.gastype != 'e10' }">E10</div>
          <div class="col-4" v-bind:class="{ 'small text-muted1': provider.gastype != 'diesel' }">Diesel</div>
        </div>

        <div v-if="!gasPrice.isOpen" class="row no-gutters align-items-center">
          <div class="col-12 gasprice">geschlossen</div>
        </div>

        <div v-if="gasPrice.isOpen" class="row no-gutters align-items-center">
          <div
            class="col-4"
            v-bind:class="{ 'gasprice': provider.gastype == 'e5', 'small text-muted1': provider.gastype != 'e5' }"
          >
            <b>
              {{gasPrice.e5}}
              <sup>9</sup>
            </b>
          </div>
          <div
            class="col-4"
            v-bind:class="{ 'gasprice': provider.gastype == 'e10', 'small text-muted1': provider.gastype != 'e10' }"
          >
            <b>
              {{gasPrice.e10}}
              <sup>9</sup>
            </b>
          </div>
          <div
            class="col-4"
            v-bind:class="{ 'gasprice': provider.gastype == 'diesel', 'small text-muted1': provider.gastype != 'diesel' }"
          >
            <b>
              {{gasPrice.diesel}}
              <sup>9</sup>
            </b>
          </div>
        </div>

        <div class="row no-gutters align-items-center">
          <div class="col-12 text-truncate">{{gasPrice.name}}</div>
        </div>

        <div class="row no-gutters align-items-center">
          <div class="col-12 small text-muted1">{{gasPrice.street}} {{gasPrice.house_number}}</div>
        </div>

        <div class="row no-gutters align-items-center">
          <div class="col-4">
            <button
              v-show="gasPrice.isFav"
              type="button"
              class="btn btn-link text-muted1"
              @click="setAsFavourite(gasPrice.id)"
            >
              <i class="fas fa-star"></i>
            </button>
            <button
              v-show="!gasPrice.isFav"
              type="button"
              class="btn btn-link text-muted1"
              @click="setAsFavourite(gasPrice.id)"
            >
              <i class="far fa-star"></i>
            </button>
          </div>
          <div class="col-4 text-muted1">
            <a :href="'geo:'+gasPrice.lat+','+gasPrice.lng" class="text-muted1">
              <i class="fas fa-map-marker-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <content-static-provider-wait v-if="isLoading" />
  </div>
</template>

<script>
import axios from "axios";
import ContentStaticProviderWait from "@/components/ContentStaticProviderWait.vue";
import ContentStaticProviderError from "@/components/ContentStaticProviderError.vue";

export default {
  name: "RenderGasPrice",
  components: {
    ContentStaticProviderWait,
    ContentStaticProviderError
  },
  data: function() {
    return {
      isLoading: false,
      hasError: false,
      gasPriceData: { stations: [] },
      favouriteStations: { stations: [] }
    };
  },
  computed: {
    gasStations() {
      let gasStations = this.gasPriceData.stations.slice();

      let sorted = gasStations.sort((a, b) => {
        //let isAFav = this.favouriteStations.stations.includes(a.id);
        //let isbFav = this.favouriteStations.stations.includes(b.id);

        let aPrice = 0;
        let bPrice = 0;
        if (this.provider.gastype == "e5") {
          aPrice = a.e5;
          bPrice = b.e5;
        } else if (this.provider.gastype == "e10") {
          aPrice = a.e10;
          bPrice = b.e10;
        } else if (this.provider.gastype == "diesel") {
          aPrice = a.diesel;
          bPrice = b.diesel;
        }

        if (aPrice == null && bPrice == null) return 0;
        else if (aPrice == null) return 1;
        else if (bPrice == null) return -1;
        else if (aPrice < bPrice) return -1;
        else if (aPrice > bPrice) return 1;
        else return 0;
      });

      gasStations.forEach(item => {
        item.isFav = this.favouriteStations.stations.includes(item.id);

        item.e5 = this.convert2decimals(item.e5);
        item.e10 = this.convert2decimals(item.e10);
        item.diesel = this.convert2decimals(item.diesel);
      });

      return sorted;
    }
  },
  props: {
    provider: {}
  },
  methods: {
    convert2decimals: function(price) {
      let e5 = price;

      if (e5 == null) {
        return "--.-";
      } else {
        e5 *= 100;
        e5 = Math.floor(e5) / 100;
        return e5.toFixed(2);
      }
    },
    setAsFavourite: function(stationId) {
      if (this.favouriteStations.stations.includes(stationId)) {
        let lastIndex = this.favouriteStations.stations.lastIndexOf(stationId);
        this.favouriteStations.stations.splice(lastIndex, 1);
      } else {
        this.favouriteStations.stations.push(stationId);
        localStorage.setItem(
          "GasPriceFav",
          JSON.stringify(this.favouriteStations)
        );
      }
    },
    loadGasPrice: function() {
      this.isLoading = true;

      this.hasError = false;

      let requestURL = this.provider.url;

      axios
        .get(requestURL, {
          responseType: "json"
        })
        .then(response => {
          if (response == "") {
            this.hasError = true;
          } else {
            this.gasPriceData = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.loadGasPrice();
    if (window.localStorage.getItem("GasPriceFav")) {
      this.favouriteStations = JSON.parse(
        window.localStorage.getItem("GasPriceFav")
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}

.fav-gas {
  background-color: rgb(23, 162, 184);
}

.fav-gas .row .text-muted1{
  color: rgb(92, 73, 73);
}

.fav-gas .row .gasprice {
  color: yellow;
}

.row .text-muted1{
  color: gray;
}

.row .gasprice {
  color: #563d7c;
}

.i42Icon {
  max-height: 20px;
  width: auto;
}

.action-item {
  display: inline-block;
  font-size: 0.875rem;
  cursor: pointer;
  color: #8492a6;
  background: 0 0;
  border: 0;
  padding: 0.25rem 0.25rem;
  transition: color 0.3s;
}
</style>
